import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  AfterViewInit,
  OnChanges,
} from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { SchedulingTypes } from "../../../shared/constants";
import { DevicesService } from "../../devices/devices.service";
import { SchedulingService } from "../scheduling.service";
import { SortablejsOptions } from "angular-sortablejs/dist";
import { cloneDeep } from "lodash";
import { MatSliderModule } from "@angular/material/slider";
import { SchedulingPlcUpdateDialogComponent } from "./scheduling-plc-update-dialog/scheduling-plc-update-dialog.component";
import { MatDialogRef, MatDialog } from "@angular/material";
import { SchedulingSchedulesDialogComponent } from "./scheduling-schedules-dialog/scheduling-schedules-dialog.component";
import { Scheduling, Schedule, PowerLimitControl } from "../scheduling.model";
import { GeneralService } from "../../../shared/services/general.service";
import { findIndex } from "rxjs/operators";
import { SessionStateService } from "../../../core/services/session-state.service";
import {
  DeviceType,
  GROUP,
  ClimatizationDeviceType,
} from "../../devices/devices.constant";
import { Device } from "../../devices/devices.model_new";
import { SCHEDULE_TYPE, SchedulingType } from "../scheduling.constants";
import { Observable } from "rxjs/Observable";
import { HOUSE_TARIFF } from "../../houses/houses.constants";
import { HousesService } from "../../houses/houses.service";
import "rxjs/add/observable/empty";
import { empty } from "rxjs/Observer";
import { of } from "rxjs/observable/of";

@Component({
  selector: "app-scheduling-tab",
  templateUrl: "./scheduling-tab.component.html",
  styleUrls: ["./scheduling-tab.component.scss"],
})
export class SchedulingTabComponent implements OnInit {
  loading = false;
  loadingPowerLimit = false;
  devicesBySchedulingType: Map<string, Device[]>;
  allPowerDevices: Device[];
  keyArrays: string[];

  scheduling: Scheduling = new Scheduling();
  powerLimitControl: PowerLimitControl;
  contractedPower: number;

  haveSmartMeter = false;

  options: SortablejsOptions = {};

  @Input() defaultTab: string;
  tab: string;

  @Output()
  change: EventEmitter<boolean> = new EventEmitter<boolean>();

  visible: boolean[] = [];

  dialogRef: MatDialogRef<SchedulingPlcUpdateDialogComponent>;
  dialogRefSchedules: MatDialogRef<SchedulingSchedulesDialogComponent>;

  constructor(
    private route: ActivatedRoute,
    private devicesService: DevicesService,
    private housesService: HousesService,
    private schedulingService: SchedulingService,
    private generalService: GeneralService,
    private sessionStateService: SessionStateService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.tab = this.defaultTab;
    this.devicesBySchedulingType = new Map<string, Device[]>();

    this.route.queryParams.subscribe((values) => {
      if (values.schedulingType) {
        this.tab = values.schedulingType;
      }
      if (this.tab !== this.defaultTab) {
        this.change.emit(values.schedulingType !== undefined);
      }
      this.getSchedulingType();
    });
    this.options = {
      onUpdate: (event: any) => {
        const toUpdatePlc: PowerLimitControl = cloneDeep(
          this.powerLimitControl
        );
        toUpdatePlc.setPriorityDisconnect(
          this.devicesBySchedulingType
            .get("Power Limit Control")
            .map((d) => d.getModuleId())
        );
        this.updatePowerLimitControlOrder(toUpdatePlc);
      },
      handle: ".my-handle",
    };
  }

  getSchedulingType() {
    this.loading = true;
    this.devicesBySchedulingType.clear();
    this.scheduling = new Scheduling();
    this.keyArrays = [];
    switch (this.tab) {
      case SchedulingType.ON_OFF: {
        this.devicesService
          .getHouseModules(
            this.sessionStateService.getHouse().houseId,
            DeviceType.CONSUMPTION,
            undefined,
            GROUP.SWITCH
          )
          .map((res) => {
            this.devicesBySchedulingType.set("All Devices", res);
          })
          .flatMap(() => this.getAllSchedules(SCHEDULE_TYPE.ON_OFF))
          .catch((e: any) => of(false))
          .finally(() => {
            this.loading = false;
            this.keyArrays = Array.from(this.devicesBySchedulingType.keys());
          })
          .subscribe();
        break;
      }
      case SchedulingType.ECONOMIC: {
        this.devicesService
          .getHouseModules(
            this.sessionStateService.getHouse().houseId,
            DeviceType.CONSUMPTION,
            undefined,
            GROUP.SWITCH
          )
          .map((res) => (this.allPowerDevices = res))
          .concatMap(() => {
            if (
              this.sessionStateService.getHouseTariff().tariff !==
              HOUSE_TARIFF.SIMPLE
            ) {
              this.devicesBySchedulingType.set(
                "Low-cost Schedule Period",
                this.allPowerDevices
              );
              return this.getAllSchedules(SCHEDULE_TYPE.ECONOMIC);
            } else {
              return Observable.empty();
            }
          })
          .catch((e: any) => of(false))
          .finally(() => (this.loading = false))
          .subscribe(
            () =>
              (this.keyArrays = Array.from(this.devicesBySchedulingType.keys()))
          );
        break;
      }
      case SchedulingType.STANDBY_KILLER: {
        ///
        this.devicesService
          .getHouseModules(
            this.sessionStateService.getHouse().houseId,
            DeviceType.CONSUMPTION,
            undefined,
            GROUP.SWITCH
          )
          .map((res) => {
            this.devicesBySchedulingType.set("Standby Killer Schedule", res);
          })
          .flatMap(() => this.getAllSchedules(SCHEDULE_TYPE.STAND_BY_KILLER))
          .catch((e: any) => of(false))
          .finally(() => {
            this.loading = false;
            this.keyArrays = Array.from(this.devicesBySchedulingType.keys());
          })
          .subscribe();
        break;
      }
      case SchedulingType.SETPOINT: {
        this.devicesService
          .getHouseModulesByGroups(
            this.sessionStateService.getHouse().houseId,
            DeviceType.CLIMATIZATION,
            undefined,
            [GROUP.HVAC, GROUP.THERMOSTAT]
          )
          .map((res) => (this.allPowerDevices = res))
          .catch((e: any) => of(false))
          .concatMap(() => {
            this.devicesBySchedulingType.set(
              "SetPoint devices",
              this.allPowerDevices
            );
            return this.getAllSchedules(SCHEDULE_TYPE.THERMOSTAT);
          })
          .catch((e: any) => of(false))
          .finally(() => {
            this.loading = false;
          })
          .subscribe(
            () =>
              (this.keyArrays = Array.from(this.devicesBySchedulingType.keys()))
          );
        break;
      }
      case SchedulingType.POWER_LIMIT_CONTROL: {
        this.housesService
          .getHouseContractedPower(this.sessionStateService.getHouse().houseId)
          .map((res) => (this.contractedPower = res.contractedPower))
          .flatMap(() =>
            this.schedulingService
              .getPowerLimitControl(this.sessionStateService.getHouse().houseId)
              .map((res) => {
                this.powerLimitControl = res;
                //   console.log(this.powerLimitControl);
              })
          )
          .catch((err) => {
            this.powerLimitControl = PowerLimitControl.createDummyPLC();
            return of(empty);
          })
          .flatMap(() =>
            this.devicesService
              .getHouseModules(
                this.sessionStateService.getHouse().houseId,
                undefined,
                undefined,
                undefined
              )
              .map(
                (res) => {
                  this.validatePowerControlConfigured(res);
                  this.allPowerDevices = res.filter(this.filterSwitch);
                  this.getSelectedPowerDevices();
                },
                (err) => console.error(err)
              )
          )
          .finally(() => {
            this.loading = false;
            this.keyArrays = Array.from(this.devicesBySchedulingType.keys());
          })
          .subscribe();
        break;
      }
      default: {
        this.loading = false;
        break;
      }
    }
  }

  filterSwitch(element: Device, index: number, array: Device[]) {
    return (
      element.getGroups().has(GROUP.SWITCH) &&
      !element.getGroups().has(GROUP.PRODUCTION_METER)
    );
  }

  validatePowerControlConfigured(array: Device[]): void {
    array.forEach((element) => {
      if (
        element.getGroups().has(GROUP.SMART_ENERGY_METER) &&
        element.getGroups().has(GROUP.CONSUMPTION_METER)
      ) {
        if (element.isConnectivityStateOnline) {
          this.haveSmartMeter = true;
        }
      }
    });
  }

  getDeviceSchedules(device: Device): Schedule[] {
    return this.scheduling.getSchedules(device);
  }

  openSchedulesDialog(device: Device): void {
    this.dialogRefSchedules = this.dialog.open(
      SchedulingSchedulesDialogComponent,
      {
        data: {
          device: device,
          scheduling: new Scheduling(
            cloneDeep(this.getDeviceSchedules(device))
          ),
          type: this.getSchedulingTypeByTab(device),
        },
        autoFocus: false,
        panelClass: "inputPopup",
      }
    );

    const sub = this.dialogRefSchedules.componentInstance.updateScheduling.subscribe(
      (s: Schedule) => {
        if (
          !this.scheduling
            .getSchedules()
            .find((schedule) => schedule.getId() === s.getId())
        ) {
          this.scheduling.addSchedule(s);
        } else if (s.toDelete) {
          this.scheduling.removeSchedule(s);
        } else if (!s.toDelete) {
          this.scheduling.updateSchedule(s);
        }
      }
    );
  }

  getSchedulingTypeByTab(device?: Device): SCHEDULE_TYPE[] {
    switch (this.tab) {
      case SchedulingType.ON_OFF: {
        return [SCHEDULE_TYPE.ON_OFF];
      }
      case SchedulingType.ECONOMIC: {
        return [SCHEDULE_TYPE.ECONOMIC];
      }
      case SchedulingType.SETPOINT: {
        if (device.getSubType() === ClimatizationDeviceType.AIR_CONDITIONING) {
          return [SCHEDULE_TYPE.HVAC];
        } else {
          return [SCHEDULE_TYPE.THERMOSTAT];
        }
      }
      case SchedulingType.STANDBY_KILLER: {
        return [SCHEDULE_TYPE.STAND_BY_KILLER];
      }
      default: {
        return undefined;
      }
    }
  }

  openPlcDialog(): void {
    this.dialogRef = this.dialog.open(SchedulingPlcUpdateDialogComponent, {
      data: {
        devices: cloneDeep(this.allPowerDevices),
        moduleIds: cloneDeep(this.powerLimitControl.getPriorityDisconnect()),
      },
      autoFocus: false,
      panelClass: "inputPopup",
    });

    const sub = this.dialogRef.componentInstance.action.subscribe(
      (moduleIds: string[]) => {
        this.dialogRef.close();
        const toUpdatePlc: PowerLimitControl = cloneDeep(
          this.powerLimitControl
        );
        toUpdatePlc.setPriorityDisconnect(moduleIds);
        this.updatePowerLimitControl(toUpdatePlc);
      }
    );
  }

  onPowerControlSwitch() {
    const toUpdatePlc: PowerLimitControl = cloneDeep(this.powerLimitControl);
    if (toUpdatePlc.getEnabled()) {
      this.loadingPowerLimit = true;
      this.schedulingService
        .deconfigurePowerLimitControl(
          this.sessionStateService.getHouse().houseId
        )
        .finally(() => (this.loadingPowerLimit = false))
        .subscribe((res) => this.powerLimitControl.setEnabled(false));
    } else {
      toUpdatePlc.setEnabled(true);
      this.loadingPowerLimit = true;
      this.schedulingService
        .updatePoweLimitControl(
          this.sessionStateService.getHouse().houseId,
          toUpdatePlc
        )
        .finally(() => (this.loadingPowerLimit = false))
        .subscribe((res) => (this.powerLimitControl = toUpdatePlc));
    }
  }

  onCuttOffPowerChange(event) {
    const toUpdatePlc: PowerLimitControl = cloneDeep(this.powerLimitControl);
    toUpdatePlc.setPowerLimit(Number(event.value));
    this.updatePowerLimitControl(toUpdatePlc);
  }

  private getAllSchedules(scheduleType: SCHEDULE_TYPE): Observable<any> {
    return this.schedulingService
      .getScheduling(
        this.sessionStateService.getHouse().houseId,
        undefined,
        scheduleType
      )
      .map((res) => (this.scheduling = res));
  }

  private updatePowerLimitControl(powerLimitControl: PowerLimitControl) {
    // console.log(powerLimitControl);
    this.loadingPowerLimit = true;
    this.schedulingService
      .updatePoweLimitControl(
        this.sessionStateService.getHouse().houseId,
        powerLimitControl
      )
      .finally(() => {
        this.loadingPowerLimit = false;
      })
      .subscribe((res) => {
        this.powerLimitControl = powerLimitControl;
        this.devicesBySchedulingType.set(
          "Power Limit Control",
          this.getSelectedPowerDevices()
        );
      });
  }

  private updatePowerLimitControlOrder(powerLimitControl: PowerLimitControl) {
    this.schedulingService
      .updatePoweLimitControl(
        this.sessionStateService.getHouse().houseId,
        powerLimitControl
      )
      .finally(() => {
        // this.loadingPowerLimit = false;
      })
      .subscribe((res) => {
        this.powerLimitControl = powerLimitControl;
        this.devicesBySchedulingType.set(
          "Power Limit Control",
          this.getSelectedPowerDevices()
        );
      });
  }

  private getSelectedPowerDevices(): Device[] {
    const selectedDevices: Device[] = [];
    if (this.powerLimitControl.getPriorityDisconnect()) {
      this.powerLimitControl.getPriorityDisconnect().forEach((id) => {
        const device = this.allPowerDevices.find((d) => d.getModuleId() === id);
        if (device) {
          selectedDevices.push(device);
        }
      });
    }
    this.devicesBySchedulingType.set("Power Limit Control", selectedDevices);
    return selectedDevices;
  }

  getActive(devices) {
    if (!devices) {
      return [];
    }
    return devices.filter((dev) => dev.getConnectivityState() !== "offline");
  }

  getInactive(devices) {
    if (!devices) {
      return [];
    }
    return devices.filter((dev) => dev.getConnectivityState() === "offline");
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/scheduling/scheduling-tab/scheduling-tab.component.ts